// post-numbers.ts — (tf3-35a; planning 17:05 item 3) the numbers panel's words, pure: each posted version's numbers per
// platform (GET /api/videos/:id/post-numbers). A platform that hasn't reported yet says so; a number a platform doesn't
// report is "—", never 0; until the workers' read is live the panel says the numbers aren't available yet.
import { w, PAGE_WORDS } from "@/lib/words.ts";   // (B107) the panel's words, editable in Admin → Words (defaults kept for the tests)
export const NUMBER_COLUMNS = [["views", "Views"], ["reach", "Reach"], ["likes", "Likes"], ["comments", "Comments"], ["shares", "Shares"], ["saves", "Saves"]] as const;
/** a column's head, as shown */
export const columnLabel = (k: typeof NUMBER_COLUMNS[number][0]): string => w(`page.numbers.${k}`);
export type NumberKey = typeof NUMBER_COLUMNS[number][0];
export type PostNumbersRow = { targetId: string; postId: string; channelId: string; channel: string; permalink: string | null; fetchedAt: string | null; reported: boolean }
  & Record<NumberKey, number | null>;
export type PostNumbersAnswer = { available: boolean; rows: PostNumbersRow[] };

const PLATFORM: Record<string, string> = { youtube: "YouTube", tiktok: "TikTok", instagram: "Instagram" };
export const platformName = (c: string) => PLATFORM[c] ?? c;
export const NUMBERS_NOT_AVAILABLE = PAGE_WORDS["page.numbers.not_yet"];
export const NUMBERS_NONE_YET = PAGE_WORDS["page.numbers.shows_once"];
export const NOT_REPORTED_NOTE = PAGE_WORDS["page.numbers.not_reported"];

/** Pure: a cell — the number, "—" when the platform has none; blank while it hasn't reported. */
export function cell(r: PostNumbersRow, k: NumberKey): string {
  if (!r.reported) return "";
  const v = r[k];
  return v === null ? "—" : v.toLocaleString("en-US");
}
/** Pure: the row's status line ("hasn't reported yet" until the first numbers arrive). */
export const statusOf = (r: PostNumbersRow): string | null => (r.reported ? null : w("page.numbers.platform_not_yet", { platform: platformName(r.channel) }));
/** Pure: what the panel says above (or instead of) its table. */
export function panelNote(a: PostNumbersAnswer): string | null {
  if (!a.available) return w("page.numbers.not_yet");
  if (a.rows.length === 0) return w("page.numbers.shows_once");
  return null;
}
/** Pure: whether the "—" note is needed. */
export const needsDashNote = (rows: PostNumbersRow[]) => rows.some((r) => r.reported && NUMBER_COLUMNS.some(([k]) => r[k] === null));
